export const ARTICLES_URL = Object.freeze({
  path: '/articles',
  list: {
    name: 'article.list',
    path: '/articles/list',
  },
  view: {
    name: 'article.view',
    path: '/articles/view/:id',
  },
  track: {
    name: 'article.track',
    path: '/track/:track/article/:id',
  },
  edit: {
    name: 'article.edit',
    path: '/articles/edit/:id',
  },
  create: {
    name: 'article.create',
    path: '/articles/create',
  },
  answer: {
    name: 'article.answer',
    path: '/articles/answer/:question_id',
  },
  notfound: {
    name: 'article.notfound',
    path: '/articles/notfound',
  },
  forbidden: {
    name: 'article.forbidden',
    path: '/articles/forbidden',
  },
  denied: {
    name: 'article.denied',
    path: '/articles/denied',
  },
});

export const NO_ARTICLE_IMAGE = 'no-image.png';

export const ARTICLE_BLOCK_TYPES = {
  LIST: 'list',
  IMAGE: 'image',
  HEADER: 'header',
  PARAGRAPH: 'paragraph',
};

export const ARTICLE_ACCESS = {
  0: 'public',
  1: 'department-only',
  2: 'private',
};

export const ARTICLE_ACCESS_INFO = {
  0: 'public-article-access-info',
  1: 'department-article-access-info',
  2: 'private-article-access-info',
};

export const ARTICLE_ERRORS = {
  404: 'ARTICLE_NOT_FOUND',
  403: 'FORBIDDEN',
  401: 'PERMISSION_DENIED',
};
